export default "__VITE_ASSET__CQhAXEMx__"